import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';
import {BaseCodeDisplayer} from './_Base';
import {BaseMatNodeType} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/mat/_Base';
import {MaterialCompileHelper} from '../CompileHelper';
import {ShaderMaterial} from 'three';

export class VertexAndFragmentCodeDisplayer {
	static async update(node: BaseMatNodeType, shadersByName: Ref<PolyDictionary<string>>, shaderNames: Ref<string[]>) {
		const shaderMaterial = (await node.material()) as ShaderMaterial;
		await node.compute();
		await MaterialCompileHelper.compile(shaderMaterial);
		BaseCodeDisplayer.clear(shadersByName, shaderNames);
		if (shaderMaterial.vertexShader) {
			shadersByName.value['vertex'] = shaderMaterial.vertexShader;
			shaderNames.value.push('vertex');
		}
		if (shaderMaterial.fragmentShader) {
			shadersByName.value['fragment'] = shaderMaterial.fragmentShader;
			shaderNames.value.push('fragment');
		}
	}
}
